import { toast } from 'sonner'
import { fError } from '@/utils/format-error'
import axios, { endpoints } from '@/lib/axios'
import { useBoolean } from '@/hooks/use-boolean'
import { useEffect, useMemo, useState } from 'react'
import { useParams } from '@/routes/hooks/use-params'
import LoadingSection from '@/components/loading-indicator/loading-section'

import { RedeemCondition } from '../privilege.types'
import RedeemConditionForm, {
  RedeemConditionPayload,
} from '../redeem-condition-form'

export default function RedeemConditionView() {
  const params = useParams()
  const privilegeId = useMemo(() => params?.id as string | undefined, [params])

  const [condition, setCondition] = useState<RedeemCondition | undefined>(
    undefined,
  )

  // const [conditions, setConditions] = useState<RedeemCondition[]>([])
  // const [editDialogOpen, setEditDialogOpen] = useState(false)
  // const [editingIndex, setEditingIndex] = useState<number | null>(null)

  const loading = useBoolean(true)

  const fetchRedeemConditions = async () => {
    if (!privilegeId) return
    try {
      loading.onTrue()
      const { data } = await axios.get<RedeemCondition[]>(
        endpoints.privileges.redeemCondition(privilegeId),
      )

      console.log('fetchRedeemConditions', data)

      if (data.length > 0) {
        setCondition(data[0])
      }
    } catch (error) {
      toast.error(fError(error))
    } finally {
      loading.onFalse()
    }
  }

  useEffect(() => {
    fetchRedeemConditions()
  }, [privilegeId])

  const handleCreateOrUpdateSubmit = async (
    payload: RedeemConditionPayload,
  ): Promise<void> => {
    if (!privilegeId) return

    const isUpdate = condition && condition.id
    const actionText = isUpdate ? 'อัปเดต' : 'เพิ่ม'

    try {
      if (isUpdate) {
        // Check if there are actual changes before making API call
        const hasChanges =
          condition.type !== payload.type ||
          condition.amount !== payload.amount ||
          condition.currency !== payload.currency ||
          condition.tokenId !== payload.tokenId

        if (!hasChanges) {
          toast.info('ไม่มีการเปลี่ยนแปลงใดๆ')
          return
        }

        // Update existing condition
        await axios.patch(
          endpoints.privileges.redeemConditionById(privilegeId, condition.id),
          payload,
        )
      } else {
        // Create new condition
        await axios.post(endpoints.privileges.redeemCondition(privilegeId), [
          payload,
        ])
      }

      toast.success(`${actionText}เงื่อนไขการแลกสำเร็จ`)
      await fetchRedeemConditions()
    } catch (error) {
      console.error('Error in handleCreateOrUpdateSubmit:', error)
      toast.error(`เกิดข้อผิดพลาดในการ${actionText}เงื่อนไขการแลก`)
      throw error // Re-throw to let the form handle the error state
    }
  }

  // const handleEditClick = (index: number) => {
  //   setEditingIndex(index)
  //   setEditDialogOpen(true)
  // }

  // const handleEditSubmit = (condition: RedeemCondition) => {
  //   if (editingIndex === null) return
  //   setConditions((prev) =>
  //     prev.map((item, idx) => (idx === editingIndex ? condition : item)),
  //   )
  // }

  // const handleDelete = (index: number) => {
  //   setConditions((prev) => prev.filter((_, i) => i !== index))
  // }

  // const renderTypeBadge = (type: RedeemConditionType) => {
  //   switch (type) {
  //     case RedeemConditionType.TOKEN:
  //       return <Badge variant="outline">Token</Badge>
  //     default:
  //       return <Badge variant="secondary">-</Badge>
  //   }
  // }

  return (
    <div className="space-y-6">
      <LoadingSection loading={loading.value}>
        <RedeemConditionForm
          initialCondition={condition}
          onSubmit={handleCreateOrUpdateSubmit}
        />
      </LoadingSection>

      {/* <Card className="p-0">
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-40">ประเภท</TableHead>
                <TableHead className="w-40">จำนวน</TableHead>
                <TableHead className="w-40">สกุลเงิน / Token</TableHead>
                <TableHead className="w-16" />
              </TableRow>
            </TableHeader>
            <TableBody>
              {conditions.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    className="text-center text-sm text-muted-foreground"
                  >
                    ยังไม่มีเงื่อนไขการแลก
                  </TableCell>
                </TableRow>
              ) : (
                conditions.map((c, index) => (
                  <TableRow key={index}>
                    <TableCell>{renderTypeBadge(c.type)}</TableCell>
                    <TableCell>{c.amount || 0}</TableCell>
                    <TableCell>{c.currency || '-'}</TableCell>
                    <TableCell className="text-right">
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <Button variant="ghost" size="sm">
                            <MoreHorizontal className="h-4 w-4" />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end">
                          <DropdownMenuItem
                            onClick={() => handleEditClick(index)}
                          >
                            <Pencil className="mr-2 h-4 w-4" />
                            แก้ไข
                          </DropdownMenuItem>
                          <DropdownMenuItem
                            onClick={() => handleDelete(index)}
                            className="text-destructive"
                          >
                            <Trash2 className="mr-2 h-4 w-4" />
                            ลบ
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Dialog open={editDialogOpen} onOpenChange={setEditDialogOpen}>
        <DialogContent className="sm:max-w-2xl">
          <DialogHeader>
            <DialogTitle>แก้ไขเงื่อนไขการแลก</DialogTitle>
          </DialogHeader>
          {editingIndex !== null && (
            <RedeemConditionForm
              initialCondition={conditions[editingIndex]}
              onCancel={() => setEditDialogOpen(false)}
              onSubmit={(val) => {
                handleEditSubmit(val)
                setEditDialogOpen(false)
              }}
            />
          )}
        </DialogContent>
      </Dialog> */}
    </div>
  )
}
